// extracted by mini-css-extract-plugin
export default {"loadAction":"shiVG","borderBottom":"V1pSw"};